module.exports = __webpack_public_path__ + "static/media/SettingsIconInactive.bf34becc.png";